import { alpha, Card, styled } from "@mui/material";
import { useContext } from "react";
import { useGetLinkDetailsRequest } from "src/services/link/queries/details";
import palette from "src/theme/palette";

import Powered from "../Common/InfoStep/components/Powered";
import ThemeContext from "../context";
import { useGetLinkEntities } from "../services/useGetLinkEntities";
import { useStartFlow } from "../services/useStartFlow";
import ConnectAccountContent from "./ConnectAccountContent";
import Context from "./context";
import { useGetUpdateConnection } from "./services/useGetUpdateConnection";

const CustomCard = styled(Card)<{
	contentBackgroundColor?: string;
	type: string;
}>(({ contentBackgroundColor, type, theme }) => {
	const shadowColor = type === "dark" ? "#000000" : palette.light.grey[500];
	return {
		padding: "2rem",
		paddingBottom: "5rem",
		marginBottom: "5rem",
		width: "auto",
		backgroundColor: contentBackgroundColor,
		boxShadow: `0 0 2px 0 ${alpha(shadowColor, 0.2)}, 0 12px 24px -4px ${alpha(shadowColor, 0.12)}`,
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			marginBottom: 0,
			height: "100%"
		}
	};
});

// ----------------------------------------------------------------------

export const ConnectAccountCard = () => {
	const { updateToken, restoreToken } = useContext(Context);
	const { id, state, theme, themeType, isFrame } = useContext(ThemeContext);

	const isUpdate = updateToken && updateToken !== "";
	const isReset = restoreToken && restoreToken !== "";

	const { isError, isLoading: isLoadingInfo } =
		isUpdate || isReset ? useGetUpdateConnection() : useGetLinkEntities();

	const { isLoading: isLoadingStart } = useStartFlow({});

	const { isLoading } = useGetLinkDetailsRequest(id);

	return (
		<CustomCard
			contentBackgroundColor={theme?.colors.contentBackground}
			type={themeType}
			sx={{ pb: !isFrame ? 10 : "2rem", px: { sm: "2rem", xs: "1.5rem" } }}
		>
			<ConnectAccountContent
				isError={state.isNotContracted || isError || !!state.errorMessage}
				isLoading={isLoading || isLoadingStart || isLoadingInfo}
				step={state.step}
			/>
			{!isFrame && <Powered />}
		</CustomCard>
	);
};

export default ConnectAccountCard;
